export default "__VITE_ASSET__DI8vcPY6__"